export const AUTO_PREFIX = {};
const transform = AUTO_PREFIX;
export default transform;